import React, { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Paper,
  Button,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomSearchBar from "../Lease Module/CustomSearchBar";
import BankAuctionReusableCard from "./BankAuctionReusableCard";
import CustomBottomNav from "../Rent Module/BottomNavbar/BottomNavbar";
import { BASE_URL } from "../../Api/ApiUrls";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';
// Fix Leaflet default icon issue
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { AuthContext } from "../../AuthContext/AuthContext";
import GuestLoginModal from "../../GuestLoginModal";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

// BANK AUCTION API 
const BANK_API = `${BASE_URL}/auction-property/`;

// Property type filter options
// const rentalTypes = [
//   "PLOT/LAND", "COMMERCIAL LAND/PLOT", "RENT WITH DUPLEX BUILDING", "DUPLEX HOUSE",
//   "RENTAL BUILDING", "PG-OFFICES", "FLAT", "VILLA",
//   "COMMERCIAL BUILDING", "APARTMENT", "JV/JD"
// ];

const rentalTypes = [
  'Plots',
    'Residential Building',
    'Commercial Building',
    'Land',
    'Flat',
    'House',
    'Villa'];

const PostBankMap = () => {
  const navigate = useNavigate();

      const { isGuest } = useContext(AuthContext);
        const [showGuestModal, setShowGuestModal] = useState(false);
  // --- STATE ---
  const [properties, setProperties] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [visibleProperties, setVisibleProperties] = useState([]);
  const [activePropertyId, setActivePropertyId] = useState(null);
  const [searchLocation, setSearchLocation] = useState(null);
  const [selectedPropertyType, setSelectedPropertyType] = useState(null);
  const [priceFilter, setPriceFilter] = useState(null);
  // State for carousel arrows
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);
        const [showSuccess, setShowSuccess] = useState(false);
      const [showFailure, setShowFailure] = useState(false);
      const [alertMessage, setAlertMessage] = useState('');
    
const [isLoading, setIsLoading] = useState(true);

  const mapContainerRef = useRef(null);
  const cardListRef = useRef(null);

  const [map, setMap] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [mapLoaded, setMapLoaded] = useState(false);

  const [currentBounds, setCurrentBounds] = useState(null);
  const [mapKey, setMapKey] = useState(0);

  // Refs for controlling behavior
  const skipMapPanRef = useRef(false);
  const isProgrammaticScrollRef = useRef(false);
  const scrollTimeoutRef = useRef(null);
  const scrollDebounceRef = useRef(null);
  const lastActiveIdRef = useRef(null);
  const isPointerOverCarouselRef = useRef(false);

  const searchLocationMarkerRef = useRef(null);

  // Disable map interactions when interacting with carousel
  const disableMapInteractions = () => {
    if (!map) return;
    try {
      if (map.dragging && map.dragging.enabled()) map.dragging.disable();
      if (map.touchZoom && map.touchZoom.enabled()) map.touchZoom.disable();
      if (map.doubleClickZoom && map.doubleClickZoom.enabled()) map.doubleClickZoom.disable();
      if (map.scrollWheelZoom && map.scrollWheelZoom.enabled()) map.scrollWheelZoom.disable();
    } catch (err) { /* ignore */ }
  };

  const enableMapInteractions = () => {
    if (!map) return;
    try {
      if (map.dragging && !map.dragging.enabled()) map.dragging.enable();
      if (map.touchZoom && !map.touchZoom.enabled()) map.touchZoom.enable();
      if (map.doubleClickZoom && !map.doubleClickZoom.enabled()) map.doubleClickZoom.enable();
      if (map.scrollWheelZoom && !map.scrollWheelZoom.enabled()) map.scrollWheelZoom.enable();
    } catch (err) { /* ignore */ }
  };

  // Handle carousel pointer events to disable map interactions
  useEffect(() => {
    const container = cardListRef.current;
    if (!container) return;

    const onPointerDown = (e) => {
      isPointerOverCarouselRef.current = true;
      disableMapInteractions();
    };
    
    const onPointerUp = (e) => {
      isPointerOverCarouselRef.current = false;
      setTimeout(() => enableMapInteractions(), 40);
    };
    
    const onPointerCancel = () => {
      isPointerOverCarouselRef.current = false;
      setTimeout(() => enableMapInteractions(), 40);
    };

    container.addEventListener('pointerdown', onPointerDown, { passive: true });
    window.addEventListener('pointerup', onPointerUp, { passive: true });
    container.addEventListener('pointercancel', onPointerCancel, { passive: true });
    container.addEventListener('touchcancel', onPointerCancel, { passive: true });

    return () => {
      container.removeEventListener('pointerdown', onPointerDown);
      window.removeEventListener('pointerup', onPointerUp);
      container.removeEventListener('pointercancel', onPointerCancel);
      container.removeEventListener('touchcancel', onPointerCancel);
    };
  }, [map, cardListRef.current]);
useEffect(() => {
  const fetchBankAuctions = async () => {
    try {
      setIsLoading(true);

      const res = await fetch(`${BASE_URL}/bank-properties/filter/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          include: {
            status: "Approved",   
          },
          exclude: {},
        }),
      });

      const data = await res.json(); 

      const parsed = data.data.map((item) => {
        const images = item.bank_pro_doc
          ? item.bank_pro_doc.map((doc) => ({
              id: doc.doc_id,
              url: doc.document,
              uploaded_at: doc.uploaded_at,
            }))
          : [];

        const mainImage =
          images.length > 0 ? images[0].url : null;

        const lat = item.lat ? parseFloat(item.lat) : null;
        const lng = item.long ? parseFloat(item.long) : null;

        const hasCoordinates =
          lat !== null && lng !== null && !isNaN(lat) && !isNaN(lng);

        return {
          id: String(item.bankprop_id),
          title: item.bank_name || "Property",
          property_type: item.property_type || "Unknown",
          location: item.location || "Unknown",
          city_town: item.city_town || "Unknown",
          price: item.reserve_price || 0,
          possession: item.possession || "Not specified",
          createdAt: item.created_at,
          fullData: item,

          lat: hasCoordinates ? lat : null,
          lng: hasCoordinates ? lng : null,

          images,
          mainImage,

          bank_pro_doc: item.bank_pro_doc || [],
          bank_contact_details:
            item.bank_contact_details || "Not available",

          area: item.area || 0,
          units: item.units || "",

          auction_start_datetime: item.auction_start_datetime,
          auction_end_datetime: item.auction_end_datetime,

          emd_amount: item.emd_amount || 0,
          bid_increment: item.bid_increment || 0,

          status: item.status,
        };
      });

      setProperties(parsed);

      const propertiesWithCoords = parsed.filter(
        (p) => p.lat !== null && p.lng !== null
      );

      setFilteredProperties(propertiesWithCoords);

    } catch (err) {
      console.error("Error fetching properties:", err);
    } finally {
      setIsLoading(false);
    }
  };

  fetchBankAuctions();
}, []);

  // Filter properties
  useEffect(() => {
    if (properties.length === 0) return;

    let filtered = properties.filter(p => p.lat !== null && p.lng !== null);

    // Apply property type filter
    if (selectedPropertyType) {
      filtered = filtered.filter(property => {
        const propertyType = property.property_type?.toUpperCase() || "";
        const searchType = selectedPropertyType.toUpperCase();
        return propertyType.includes(searchType);
      });
    }

    // Apply price filter
    if (priceFilter) {
      filtered = filtered.filter(property => {
        const price = property.price || 0;
        const numericPrice = Number(price);
        
        // Handle "No Min" filter (min and max are both 0)
        if (priceFilter.min === 0 && priceFilter.max === 0) {
          return true;
        }
        
        // Handle maximum value (Infinity case)
        if (priceFilter.max === Infinity) {
          return numericPrice >= priceFilter.min;
        }
        
        return numericPrice >= priceFilter.min && numericPrice <= priceFilter.max;
      });
    }

    // Sort by distance if search location is selected
    if (searchLocation) {
      const centerLat = searchLocation.lat;
      const centerLng = searchLocation.lng;
      
      filtered = filtered
        .map(prop => {
          if (!prop.lat || !prop.lng) return prop;
          const distance = L.latLng([prop.lat, prop.lng]).distanceTo([centerLat, centerLng]);
          return { ...prop, distance };
        })
        .sort((a, b) => (a.distance || Infinity) - (b.distance || Infinity));
    }

    setFilteredProperties(filtered);

    // Reset active property and scroll when filters change
    if (cardListRef.current) {
      cardListRef.current.scrollLeft = 0;
    }
    setActivePropertyId(null);

  }, [properties, selectedPropertyType, priceFilter, searchLocation]);

  // Initialize map
  useEffect(() => {
    if (!mapContainerRef.current) return;

    let initialCenter = [17.385, 78.486];
    let initialZoom = 11;

    if (searchLocation) {
      initialCenter = [searchLocation.lat, searchLocation.lng];
      initialZoom = 13;
    }

    const leafletMap = L.map(mapContainerRef.current, {
      center: initialCenter,
      zoom: initialZoom,
      zoomControl: false,
      maxZoom: 20, // Set max zoom to 20 for all users (no subscription restriction)
    });

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; OpenStreetMap contributors',
      maxNativeZoom: 20
    }).addTo(leafletMap);

    L.control.zoom({ position: "topright" }).addTo(leafletMap);

    // Handle map move
    const handleMoveEnd = () => {
      setCurrentBounds(leafletMap.getBounds());
    };

    // Handle zoom - update marker icons with price labels
    const handleZoomEnd = () => {
      const bounds = leafletMap.getBounds();
      setCurrentBounds(bounds);
      
      // Update marker icons with price labels based on zoom level
      setTimeout(() => {
        setMarkers(prevMarkers => {
          prevMarkers.forEach(m => {
            const pid = m.options.propertyId;
            const prop = filteredProperties.find(p => p.id === pid);
            if (prop && leafletMap.hasLayer(m)) {
              m.setIcon(createMarkerIconForProperty(prop, pid === activePropertyId));
            }
          });
          return [...prevMarkers];
        });
      }, 50);
    };

    leafletMap.on("moveend", handleMoveEnd);
    leafletMap.on("zoomend", handleZoomEnd);

    setMap(leafletMap);
    setMapLoaded(true);
    setCurrentBounds(leafletMap.getBounds());

    return () => {
      if (leafletMap) {
        leafletMap.off("moveend", handleMoveEnd);
        leafletMap.off("zoomend", handleZoomEnd);
        
        // Remove all layers first
        leafletMap.eachLayer(layer => {
          try {
            leafletMap.removeLayer(layer);
          } catch (e) {}
        });
        
        leafletMap.remove();
      }
      
      setMap(null);
      setMapLoaded(false);
      setMarkers([]);
    };
  }, [mapKey, searchLocation]);

  // Update map when search location changes
  useEffect(() => {
    if (map && searchLocation) {
      try {
        map.setView([searchLocation.lat, searchLocation.lng], 13, {
          animate: true
        });
        
        // Remove existing search marker
        if (searchLocationMarkerRef.current && map.hasLayer(searchLocationMarkerRef.current)) {
          map.removeLayer(searchLocationMarkerRef.current);
        }
        
        // Add new search marker
        const searchIcon = L.divIcon({
          className: 'search-location-marker',
          html: '<div style="width: 12px; height: 12px; background-color: #FF0000; border-radius: 50%; border: 2px solid white; box-shadow: 0 0 4px rgba(0,0,0,0.5);"></div>',
          iconSize: [12, 12],
          iconAnchor: [6, 6],
        });
        
        searchLocationMarkerRef.current = L.marker([searchLocation.lat, searchLocation.lng], {
          icon: searchIcon
        }).addTo(map);
          
      } catch (error) {
        console.error('Error updating map to search location:', error);
      }
    }
  }, [searchLocation, map]);

  // Update visible properties when bounds change
  useEffect(() => {
    if (!currentBounds || filteredProperties.length === 0) {
      setVisibleProperties(filteredProperties);
      return;
    }

    const inBounds = filteredProperties.filter((p) => {
      try {
        return p.lat && p.lng && currentBounds.contains(L.latLng(p.lat, p.lng));
      } catch (error) {
        return false;
      }
    });

    setVisibleProperties(inBounds);
    
    // If active property is no longer in view, clear it
    if (activePropertyId && !inBounds.find(p => p.id === activePropertyId)) {
      setActivePropertyId(null);
    }
  }, [currentBounds, filteredProperties, activePropertyId]);

  // Price label formatting
  const getPriceLabel = (price) => {
    const num = Number(price || 0);
    if (num >= 10000000) return `${Math.round(num / 10000000)} Cr`;
    if (num >= 100000) return `${Math.round(num / 100000)} L`;
    if (num >= 1000) return `${Math.round(num / 1000)} K`;
    return `${num}`;
  };

  // Create marker icon with price label
  const createMarkerIconForProperty = (property, active = false) => {
    try {
      const currentZoom = map ? map.getZoom() : 13;
      const color = active ? '#000000' : '#008000';
      const borderColor = active ? '#FF0000' : '#FFFFFF';
      const showPriceLabel = currentZoom >= 14; // Show price at zoom level 14+
      
      const baseSize = showPriceLabel ? 28 : 16;
      const scale = active ? 1.4 : 1;
      const size = baseSize * scale;
      
      const price = property.price || 0;
      const priceText = getPriceLabel(price);
      
      return L.divIcon({
        className: 'custom-marker',
        html: `
          <div style="
            position: relative;
            width: ${size}px;
            height: ${size}px;
            display: flex;
            align-items: center;
            justify-content: center;
          ">
            <div style="
              background-color: ${color};
              width: 100%;
              height: 100%;
              border-radius: 50%;
              border: 2px solid ${borderColor};
              display: flex;
              justify-content: center;
              align-items: center;
              box-shadow: 0 1px 3px rgba(0,0,0,0.3);
              box-sizing: border-box;
              overflow: hidden;
              position: relative;
              z-index: 2;
            ">
              ${showPriceLabel ? `
                <span style="
                  color: white;
                  font-size: ${Math.max(8, size * 0.4)}px;
                  font-weight: bold;
                  text-align: center;
                  line-height: 1;
                  padding: 1px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-width: 100%;
                ">
                  ${priceText}
                </span>
              ` : ''}
            </div>
          </div>
        `,
        iconSize: [size, size],
        iconAnchor: [size / 2, size / 2],
      });
    } catch (err) {
      console.error('createMarkerIconForProperty error', err);
      return L.divIcon({ className: 'custom-marker' });
    }
  };

  // Update markers when filtered properties change
  useEffect(() => {
    if (!map || !mapLoaded || filteredProperties.length === 0) return;

    try {
      // Clear existing markers
      markers.forEach(m => {
        try {
          if (map.hasLayer(m)) map.removeLayer(m);
        } catch (e) {}
      });

      // Create new markers
      const newMarkers = filteredProperties
        .filter(p => p.lat && p.lng)
        .map(property => {
          const icon = createMarkerIconForProperty(property, property.id === activePropertyId);
          const marker = L.marker([property.lat, property.lng], {
            icon,
            propertyId: property.id
          }).addTo(map);

          marker.on('click', () => {
            skipMapPanRef.current = true;
            setActivePropertyId(property.id);
            setTimeout(() => {
              scrollToCard(property.id);
              setTimeout(() => { skipMapPanRef.current = false; }, 500);
            }, 50);
          });

          if (property.id === activePropertyId) marker.setZIndexOffset(1000);
          return marker;
        });

      setMarkers(newMarkers);

      // Fit bounds to show all filtered properties
      if (filteredProperties.length > 0 && !searchLocation) {
        const coords = filteredProperties
          .filter(p => p.lat && p.lng)
          .map(p => [p.lat, p.lng]);

        if (coords.length > 0) {
          const bounds = L.latLngBounds(coords);
          map.fitBounds(bounds, {
            padding: [50, 50],
            maxZoom: 5,
            animate: true
          });
        }
      }

    } catch (error) {
      console.error('Error updating map with filtered properties:', error);
    }
  }, [filteredProperties, map, mapLoaded]);

  // Update marker when active property changes
  useEffect(() => {
    if (!map || !markers.length) return;

    markers.forEach(m => {
      try {
        const pid = m.options.propertyId;
        const prop = filteredProperties.find(p => p.id === pid);
        if (prop) {
          m.setIcon(createMarkerIconForProperty(prop, pid === activePropertyId));
          m.setZIndexOffset(pid === activePropertyId ? 1000 : 0);
        }
      } catch (err) { console.error(err); }
    });

    // Pan to active property if not skipping
    if (!skipMapPanRef.current && map && activePropertyId) {
      try {
        const activeProp = filteredProperties.find(p => p.id === activePropertyId);
        if (activeProp && activeProp.lat && activeProp.lng) {
          setTimeout(() => {
            if (map && map.panTo) {
              map.panTo([activeProp.lat, activeProp.lng], { 
                animate: true, 
                duration: 0.4 
              });
            }
          }, 50);
        }
      } catch (error) {
        console.warn('Could not pan to property:', error);
      }
    }
  }, [activePropertyId, markers, map, filteredProperties]);

  // Scroll to card function
  const scrollToCard = (propertyId) => {
    try {
      const container = cardListRef.current;
      if (!container) return;
      const el = container.querySelector(`[data-property-id="${propertyId}"]`);
      if (el) {
        isProgrammaticScrollRef.current = true;
        el.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
        clearTimeout(scrollTimeoutRef.current);
        scrollTimeoutRef.current = setTimeout(() => {
          isProgrammaticScrollRef.current = false;
        }, 450);
      }
    } catch (err) { console.error('scrollToCard error', err); }
  };

  // Detect scroll to set active property
  useEffect(() => {
    const container = cardListRef.current;
    if (!container) return;

    const onScroll = () => {
      if (isProgrammaticScrollRef.current) return;

      if (scrollDebounceRef.current) clearTimeout(scrollDebounceRef.current);
      scrollDebounceRef.current = setTimeout(() => {
        try {
          const rect = container.getBoundingClientRect();
          const centerX = rect.left + rect.width / 2;
          const cards = Array.from(container.querySelectorAll('[data-property-id]'));
          if (!cards.length) return;

          let closest = null;
          let closestDistance = Infinity;
          cards.forEach(card => {
            const cRect = card.getBoundingClientRect();
            const cardCenter = cRect.left + cRect.width / 2;
            const distance = Math.abs(cardCenter - centerX);
            if (distance < closestDistance) {
              closestDistance = distance;
              closest = card;
            }
          });

          if (closest) {
            const id = closest.getAttribute('data-property-id');
            if (id && id !== activePropertyId && id !== lastActiveIdRef.current) {
              setActivePropertyId(id);
              lastActiveIdRef.current = id;
            }
          }
        } catch (err) {
          console.error('onScroll calc error', err);
        }
      }, 150);
    };

    onScroll();

    container.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    return () => {
      container.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      clearTimeout(scrollTimeoutRef.current);
      clearTimeout(scrollDebounceRef.current);
    };
  }, [filteredProperties, activePropertyId]);

  // Check carousel scroll position for arrows
  useEffect(() => {
    const container = cardListRef.current;
    if (!container) return;

    const checkScrollPosition = () => {
      if (!container || visibleProperties.length === 0) return;
      
      const scrollLeft = container.scrollLeft;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      
      setIsAtStart(scrollLeft <= 10);
      setIsAtEnd(scrollLeft + clientWidth >= scrollWidth - 10);
    };

    const handleScroll = () => {
      checkScrollPosition();
    };

    container.addEventListener('scroll', handleScroll, { passive: true });
    checkScrollPosition();

    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [visibleProperties]);

  // Handle carousel arrow clicks (Infinite Scroll)
  const handleLeftArrowClick = () => {
    const container = cardListRef.current;
    if (!container || visibleProperties.length === 0) return;

    if (isAtStart) {
      container.scrollTo({
        left: container.scrollWidth,
        behavior: 'smooth'
      });
    } else {
      container.scrollBy({ left: -320, behavior: 'smooth' });
    }
  };

  const handleRightArrowClick = () => {
    const container = cardListRef.current;
    if (!container || visibleProperties.length === 0) return;

    if (isAtEnd) {
      container.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    } else {
      container.scrollBy({ left: 320, behavior: 'smooth' });
    }
  };

  // Handle property type click
  const handlePropertyTypeClick = (type) => {
    setSelectedPropertyType(prev => (prev === type ? null : type));
  };

  // Handle price filter change
  const handlePriceFilterChange = (range) => {
    setPriceFilter(range);
  };

  // Clear all filters
  const clearSearch = () => {
    setSearchLocation(null);
    setSelectedPropertyType(null);
    setPriceFilter(null);
    
    // Remove search location marker
    if (searchLocationMarkerRef.current && map && map.hasLayer(searchLocationMarkerRef.current)) {
      map.removeLayer(searchLocationMarkerRef.current);
      searchLocationMarkerRef.current = null;
    }
    
    setMapKey(prev => prev + 1);
    
    if (cardListRef.current) {
      cardListRef.current.scrollLeft = 0;
    }
    
    setActivePropertyId(null);
  };

  // Handle selected location from search bar
  const handleSelectedLocation = (locationData) => {
    setSearchLocation(locationData);
  };

  const handleCallSuccess = (message) => {
  setAlertMessage(message);
  setShowSuccess(true);
};

const handleCallFailure = (message) => {
  setAlertMessage(message);
  setShowFailure(true);
};
  // Handle card click
  const handleCardClick = (property) => {
    if (isGuest) {
      setShowGuestModal(true); // 👈 show guest popu
      return;
    }
    navigate(`/Post_Bankcard_indetail/${property.id}`);
  }; 

  return (
    <Box
      sx={{
        maxWidth: 480,
        mx: "auto",
        position: "relative",
        backgroundColor: "rgb(239, 231, 221)",
        minHeight: 500,
      }}
    >
      {/* Top Section with Search Bar */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          bgcolor: "rgb(239, 231, 221)",
          px: 2,
          py: 1,
        }}
      >
        <CustomSearchBar
          onPlaceSelected={handleSelectedLocation}
          onClear={clearSearch}
          onPriceFilterChange={handlePriceFilterChange}
        />
      </Box>

      {/* Title and Filters Section */}
      <Box sx={{ px: 2 }}>
        <Typography variant="subtitle1" sx={{ mb: 0.5 }}>
        Auction Properties
        </Typography>
      </Box>

      <Box sx={{ px: 2 }}>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            overflowX: 'auto',
            whiteSpace: 'nowrap',
            pb: 1,
            '&::-webkit-scrollbar': {
              display: 'none',
            },
          }}
        >
          {rentalTypes.map((type, index) => (
            <Chip
              key={index}
              label={type}
              variant="filled"
              onClick={() => handlePropertyTypeClick(type)}
              sx={{ 
                flexShrink: 0,
                bgcolor: selectedPropertyType === type ? '#000000' : 'transparent',
                color: selectedPropertyType === type ? '#ffffff' : '#000000',
                border: '1px solid black',
                fontWeight: 'bold',
                '&:hover': {
                bgcolor: selectedPropertyType === type ? '#000000' : 'transparent',
                color: selectedPropertyType === type ? '#ffffff' : '#000000',
                },
              }}
            />
          ))}
        </Box>
      </Box>

      <Box sx={{ px: 2, pb: 10, position: "relative" }}>
        {(selectedPropertyType || priceFilter) && filteredProperties.length === 0 && (
          <Box
            sx={{
              position: "absolute",
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 1002,
              width: '100%',
              textAlign: 'center'
            }}
          >
            <Box sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              padding: '20px',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
              border: '1px solid rgba(0,0,0,0.1)',
            }}>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>
                No properties found
              </Typography>
              
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {selectedPropertyType && `Category: "${selectedPropertyType}"`}
                {selectedPropertyType && priceFilter && ' • '}
                {priceFilter && `Price: ${priceFilter.label}`}
              </Typography>
              
              <Button 
                variant="outlined" 
                sx={{ mt: 2 }}
                onClick={() => {
                  setSelectedPropertyType(null);
                  setPriceFilter(null);
                }}
              >
                Clear Filters
              </Button>
            </Box>
          </Box>
        )}

        <div
          ref={mapContainerRef}
          key={`map-${mapKey}`}
          style={{
            width: "100vw",
            height: "calc(111vh - 300px)",
            marginLeft: "-16px",
            marginRight: "-16px",
            borderRadius: "6px",
            overflow: "hidden",
            background: "#eaeaea",
          }}
        >
          {!mapLoaded && (
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%'
            }}>
              <Typography>Loading map...</Typography>
            </Box>
          )}
        </div>

        {visibleProperties.length > 0 && (
          <Box
            sx={{
              position: "absolute",
              left: 0,
              right: 0,
              bottom: 72,
              zIndex: 1001,
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              pointerEvents: 'auto',
            }}
          >
            <Button
              onClick={handleLeftArrowClick}
              sx={{
                minWidth: 0,
                width: 32,
                height: 32,
                p: 1,
                left: 5,
                borderRadius: '70%',
                bgcolor: 'white',
                boxShadow: 2,
                mr: 1,
                '&:hover': { bgcolor: 'grey.200' },
                zIndex: 1002,
              }}
            >
              &lt;
            </Button>

            <Box
              ref={cardListRef}
              sx={{
                display: "flex",
                overflowX: "auto",
                gap: 2,
                flexGrow: 1,
                scrollSnapType: "x mandatory",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                "&::-webkit-scrollbar": { display: "none" },
              }}
            >
              {visibleProperties.map((prop) => (
                <Box
                  key={prop.id}
                  data-property-id={prop.id}
                  sx={{
                    flex: "0 0 280px",
                    scrollSnapAlign: "center",
                    cursor: "pointer",
                    height: "140px",
                  }}
                  onClick={() => handleCardClick(prop)}
                >
                  <div style={{ padding: 0, height: '100%' }}>
                    <BankAuctionReusableCard
                      property={prop}
                      onCardClick={() => handleCardClick(prop)}
                       onCallSuccess={handleCallSuccess}
  onCallFailure={handleCallFailure}
  showCallAlerts={true}
                    />
                  </div>
                </Box>
              ))}
            </Box>

            {/* Right Arrow */}
            <Button
              onClick={handleRightArrowClick}
              sx={{
                minWidth: 0,
                width: 32,
                height: 32,
                borderRadius: '50%',
                bgcolor: 'white',
                boxShadow: 2,
                p: 1,
                right: 5,
                ml: 1,
                '&:hover': { bgcolor: 'grey.200' },
                zIndex: 1002,
              }}
            >
              &gt;
            </Button>
          </Box>
        )}
              <GuestLoginModal
                open={showGuestModal}
                onClose={() => setShowGuestModal(false)}
              />

        {/* No Properties in View Message */}
        {visibleProperties.length === 0 && filteredProperties.length > 0 && (
          <Box sx={{
            position: "absolute",
            bottom: 10,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1001,
            backgroundColor: "rgba(255,255,255,0.9)",
            padding: "8px 16px",
            borderRadius: "4px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          }}>
            <Typography variant="body2">
              No properties in current view. Zoom or pan to see properties.
            </Typography>
          </Box>
        )}
      </Box>
      {/* Add these alert components */}
      {showSuccess && (
        <CopySuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowSuccess(false);
            setAlertMessage("");
          }}
        />
      )}
      
      {showFailure && (
        <CopyFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowFailure(false);
            setAlertMessage("");
          }}
        />
      )}

      <GuestLoginModal
        open={showGuestModal}
        onClose={() => setShowGuestModal(false)}
      />
      {/* Bottom Navigation */}
      <Paper
        sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
        elevation={3}
      >
        <CustomBottomNav />
      </Paper>
    </Box>
  );
};

export default PostBankMap;